import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_BALANCES = Symbol('balances');

export const ADMIN_BALANCES_ROUTE_NAME = Symbol('admin.balances');
export const ADMIN_BALANCES_LIST_ROUTE_NAME = Symbol('admin.balances.list');

export const BALANCES_LIST_API_URL = 'admin/affiliate_cashouts/balance/list';
export const BALANCES_DOWNLOAD_REPORT_URL = 'admin/affiliate_cashouts/balance/download_report';
export const BALANCES_LIST_QUERY_KEY = 'balances.list';
export const BALANCES_DOWNLOAD_REPORT_MUTATION_KEY = 'balances.download-report';

export const BALANCES_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.AFFILIATECASHOUTS_AFFILIATES_BALANCES_SHOW),
  DOWNLOAD_LIST: new Permission(PermissionsList.admin.AFFILIATECASHOUTS_AFFILIATES_BALANCES_DOWNLOAD),
  EDIT: new Permission(PermissionsList.admin.AFFILIATECASHOUTS_AFFILIATES_BALANCES_EDIT),
};
